import * as React from "react";
import { ContratoDetalhe } from "./detalhe";

const ContratoPage = () => {
  return (
    <React.Fragment>
      <ContratoDetalhe />
    </React.Fragment>
  );
};
export default ContratoPage;
